import React, { useState, useEffect, useRef } from "react";
import styles from './SentencesList.module.css';
import LessonInstruction from "../../containers/instruction/LessonInstruction";

const SentencesList = ({ blockData, contentIndex, audioUrl }) => {

  const [index, setIndex] = useState(contentIndex);
  const [visitedIndices, setVisitedIndices] = useState(new Set());
  const refs = useRef([]);

  useEffect(() => {
    setIndex(contentIndex);
    setVisitedIndices(new Set());
  }, [contentIndex]);

  useEffect(() => {
    const updatedVisitedIndices = new Set(visitedIndices);
    for (let i = 0; i < index; i++) {
      updatedVisitedIndices.add(i);
    }
    setVisitedIndices(updatedVisitedIndices);
  }, [index]);

  useEffect(() => {
    if (refs.current[index]) {
      window.scrollTo(0, refs.current[index].offsetTop - (window.innerHeight / 2));
    }
  }, [index, contentIndex]);

  const getAudioPath = (index) => {
    let audio = null;
    if (blockData && blockData.content && blockData.content[index]) {
      audio = blockData.content[index].sound ? blockData.content[index].sound : audioUrl;
    }

    if (!audio) return null;
    
    return process.env.REACT_APP_CLOUDFRONT_DNS + "/media/audios/" + audio;
  };

  const getHighlighted = (text) => {
    let splitText = text.split(/( )/);
    let textObj = [];
    for (let i = 0; i < splitText.length; i++) {
      if (splitText[i].includes("[") || splitText[i].includes("]")) {
        textObj.push({ word: splitText[i].replace("[", "").replace("]", ""), highLight: true });
      } else {
        textObj.push({ word: splitText[i], highLight: false });
      }
    }
    return textObj;
  };

  const searchNextInstruction = () => {
    const index = blockData.content.findIndex((item, i) => i >= contentIndex && item.type === 'instruction');
    return index === -1 ? blockData.content.length : index;
  };

  const searchLastInstruction = () => {
    for (let i = contentIndex; i >= 0; i--) {
      if (blockData.content[i].type === 'instruction') return i;
    }
    return 0;
  };

  const bgColor = blockData.content[contentIndex].type === "instruction" ? "new-bg-color" : "";
  const containerClasses = `default-card ${bgColor}`;

  return (
    <div className={containerClasses}>
      <div>
        {blockData.content[contentIndex].type === 'instruction' ? (
          <LessonInstruction
            instructionText={blockData.content[contentIndex].instruction}
            audioUrl={getAudioPath(contentIndex)}
          />
        ) : (
          <div className="bg-white">
            <div className={styles.simple_highlight_txt_bar}>
              <h2 className={styles.simple_highlight_txt_header}>{blockData.content[0].section}</h2>
            </div>
            {blockData.content.slice(searchLastInstruction() + 1, searchNextInstruction()).map((item, actualIndex) => {
              const idx = searchLastInstruction() + 1 + actualIndex;
              const isVisited = visitedIndices.has(idx);
              const isActive = idx === index;

              return (
                <div
                  ref={(el) => refs.current[idx] = el}
                  key={idx}
                  className={`${styles.simple_highlight_container} 
                              ${isActive ? styles.simple_active : ""} 
                              ${isVisited ? styles.simple_visited : ""}`}                 
                >
                  {getHighlighted(item.en).map((word, wordIndex) => (
                    <span key={wordIndex} style={{ color: word.highLight ? 'rgb(47, 157, 201)' : "black" }}>
                      {word.word}
                    </span>
                  ))}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default SentencesList;
